export default __webpack_public_path__ + "static/media/SG-Green-0004.834f1b8b.png";